<template>
	<sf-data-table
		ref="dataTable"
		paging
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		index
		:columns="torqRgstManagementCols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:addRowDatas="addRowDatas"
		:stripe="false"
		selection
		:customExcel="excelFunc"
		@changedPage="changedPage"
	>
		<template v-slot:actionsLeft>
			<!-- test code -->
			<sf-button v-if="isButton_(scrId, 'AD')" line icon="square-plue" :onClick="addAction">
				{{ getMessage_('MWCC000007') }}
			</sf-button>
			<sf-button v-if="isButton_(scrId, 'CU')" line icon="file" :onClick="saveAction">
				{{ getMessage_('MWCC000327') }}
			</sf-button>
		</template>
		<template v-slot:actionsRight>
			<!-- 엑셀템플릿 다운 -->
			<sf-button v-if="isButton_(scrId, 'EU')" line icon="file" :onClick="downExcelTemp">
				{{ getMessage_('QWCC001799') }}
			</sf-button>
			<!-- 엑셀업로드 -->
			<sf-button v-if="isButton_(scrId, 'EU')" line icon="excel" :onClick="openModal">
				{{ getMessage_('QWCC000927') }}
			</sf-button>
		</template>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'mesTm'">
				<el-time-picker v-model="slotProps.row.mesTm" value-format="HHmm" format="HH:mm" placeholder="HH:mm"> </el-time-picker>
			</template>
			<template v-if="slotProps.column.property === 'max2MesVal'">
				<el-input :value="slotProps.row.max2MesVal" @input="val => setSelectedRow(slotProps.row, val, 'max2MesVal')" maxlength="11">
				</el-input>
			</template>
			<template v-if="slotProps.column.property === 'max1MesVal'">
				<el-input :value="slotProps.row.max1MesVal" @input="val => setSelectedRow(slotProps.row, val, 'max1MesVal')" maxlength="11">
				</el-input>
			</template>
			<template v-if="slotProps.column.property === 'maxMesVal'">
				<el-input :value="slotProps.row.maxMesVal" @input="val => setSelectedRow(slotProps.row, val, 'maxMesVal')" maxlength="11">
				</el-input>
			</template>
			<!-- 토크렌치번호  -->
			<template v-if="slotProps.column.property === 'newMesEqipNo'">
				<template v-if="slotProps.row.rowType && slotProps.row.rowType === 'add'">
					<el-input v-model="slotProps.row.newMesEqipNo" maxlength="10"></el-input>
					<i class="icon-sf-search search-icon" @click="() => onMesEqipNoPopup(slotProps)"></i>
				</template>
				<template v-else>
					{{ slotProps.row.newMesEqipNo }}
				</template>
			</template>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/mmc/mmcm/TorqRgst/store/helpers';
import * as yup from 'yup';

/*엑셀다운로드 시작*/
import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
/*엑셀다운로드 끝*/

export default {
	props: {
		scrId: { type: String, default: '' },
		sendParam: { type: Object }
	},
	data() {
		return {
			addRowDatas: [],
			eqipKndCdInput: 'S',
			mesEqipNoInput: '',
			selGridRowIndex: '',
			//그리드 버튼 스타일 지정
			searchStyle: { top: '8px', right: '25px' }
		};
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		openModal() {
			// 엑셀업로드팝업 호출
			const param = {
				title: this.getMessage_('QWCC001475'), //타이틀바 값 [공정순회 항목 엑셀 업로드]
				apiGubun: 'TORQ_RGST', //업무구분값
				flag: 'I' //INSERT는 i Update U로 만듬
			};
			this.$emit('PopupOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
		},
		resetTable() {
			this.$emit('Refresh');
		},
		//isDisabled({ row }) {
		//	if (row.rowType && row.rowType === 'add') return false;
		//	else return true;
		//},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		addAction() {
			//행추가
			this.makeAddDatas();
			//this.setUpdateRows_(this.addRowDatas[0]);
			this.rows.unshift(...this.addRowDatas);
			this.addRowDatas.forEach(row => {
				this.$refs.dataTable.getTable().toggleRowSelection(row);
			});
		},
		saveAction() {
			//저장(그리드)
			const saveListRows = this.$refs.dataTable.getSelectedRows();
			try {
				if (saveListRows.length < 1) {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('MWCC000109'),
						message: this.getMessage_('MWCC000110')
					}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
					return;
				}
				//벨리데이션체크
				this.insVali.validateSync(saveListRows);

				let flag = '';

				//측정기관리번호 셋팅된 값을 체크
				saveListRows.forEach(element => {
					if (element.oldMesEqipNo != element.newMesEqipNo) {
						flag = 'E';
					}
				});
				//측정기관리번호 셋팅된 값이 틀리면 저장하면 안됨.
				if (flag == 'E') {
					throw new Error(this.getMessage_('QWCC001706'));
				}

				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000103'), clickFn: () => this.save(saveListRows) }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		resetSelection() {
			//체크박스 해제
			let checkedCount = document.getElementsByClassName('is-checked').length;
			for (let i = 0; i < checkedCount; i++) {
				document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
			}

			this.$emit('Refresh');
		},
		save(saveRows) {
			const sendData = {
				status: 1,
				data: saveRows
			};

			if (sendData.data && sendData.data.length > 0) {
				this.$sf_toggleLoading(true);
				this.setTorqRgstManagement_(sendData)
					.then(value => {
						if (value.message) {
							this.$sf_toast({
								type: value.code == 0 ? 'ok' : 'error',
								message: this.getMessage_(value.messageCd)
							});
						}
						this.resetTable();
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		},
		remove(selected) {
			const sendData = {
				status: 3,
				data: selected
			};

			this.$sf_toggleLoading(true);
			this.setTorqRgstManagement_(sendData)
				.then(response => {
					if (response.message != undefined && response.message != null) {
						this.$sf_toast({
							type: response.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.messageCd)
						});
					}
					// this.$refs.dataTable.deleteHandler(false);
					this.resetSelection();
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		makeAddDatas() {
			this.addRowDatas = [
				{
					rowType: 'add',
					mesDd: this.$moment().format('YYYY-MM-DD'),
					mesTm: '',
					oldMesEqipNo: '',
					newMesEqipNo: '',
					mesEqipNm: '',
					mdlNm: '',
					max2MesNos: '',
					max2MesVal: '',
					max1MesNos: '',
					max1MesVal: '',
					maxMesNos: '',
					maxMesVal: '',
					mesVal: '',
					spcVal: '',
					avgVal: '',
					stdDvatVal: '',
					rsltCd: '',
					rsltNm: '',
					rgnId: '',
					tableState: 'I'
				}
			];
		},
		//OP코드(공통코드)그리드 팝업 오픈 호출
		onMesEqipNoPopup(param) {
			const sendData = {
				eqipKndCd: 'S',
				mesEqipNo: param.row.newMesEqipNo
			};
			this.selGridRowIndex = param.index; //그리드에서 선택한 해당행의 인덱스.
			this.$emit('OpenGridMesEqipPopup', sendData);
		},
		setSelectedRow(row, value, key) {
			//숫자 길이 7자리, 소수점 3자리로 입력 제한
			if (key === 'max2MesVal' || key === 'max1MesVal' || key === 'maxMesVal') {
				value = value.replace(/[^-\.0-9]/g, '');
				const arr = value.toString().split('.');
				if (arr.length > 2) {
					return;
				}
				if (arr.length == 1) {
					if (value.length > 7) {
						value = value.slice(0, 7);
					}
				}
				if (arr.length == 2) {
					if (arr[1].length > 3) {
						arr[1] = arr[1].slice(0, 3);
					}
					if (arr[0].length > 7) {
						arr[0] = arr[0].slice(0, 7);
					}
					arr[1] = '.' + arr[1];
					value = arr.reduce((a, b) => a + b);
				}
			}
			row[key] = value;
		},
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			queryStr = objectToQuerystring({
				startDt: this.searchParams.startDt,
				endDt: this.searchParams.endDt,
				mesEqipNm: this.searchParams.mesEqipNm
			});

			const url = `${BASE_URL}/mmc/mmcm/torqRgst/v1/torqRgsts/excel` + queryStr;

			const params = { url, columns: this.torqRgstExcelCols };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		async downExcelTemp() {
			this.$sf_toggleLoading(true);
			try {
				await this.excelTempDown_({ apiGubun: 'TORQ_RGST' });
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || this.getMessage_('QWCC001920') }); //권한이 없거나 다운로드 할 수 없습니다.
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	},
	watch: {
		sendParam(newValue, oldValue) {
			this.commCd = this.sendParam;
			let dataArr = this.torqRgstManagements.slice();
			dataArr[this.selGridRowIndex].oldMesEqipNo = newValue.mesEqipNo;
			dataArr[this.selGridRowIndex].newMesEqipNo = newValue.mesEqipNo;
			dataArr[this.selGridRowIndex].mesEqipNm = newValue.mesEqipNm;
			dataArr[this.selGridRowIndex].mdlNm = newValue.mdlNm;
			dataArr[this.selGridRowIndex].spcVal = newValue.spcVal;
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.torqRgstManagements;
		},
		torqRgstManagementCols() {
			//그리드 컬럼
			return [
				{
					label: this.getMessage_('QWCC001692'), // 측정일자
					prop: 'mesDd',
					minWidth: '150px',
					sortable: false,
					form: {
						type: 'date',
						isDisabled: ({ row }) => {
							return row.rowType != 'add' ? true : false;
						}
					}
				},
				{
					label: this.getMessage_('QWCC001588'), // 시간
					prop: 'mesTm',
					minWidth: '150px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001695'), //토크렌치번호
					prop: 'oldMesEqipNo',
					minWidth: '1px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001695'), //토크렌치번호
					prop: 'newMesEqipNo',
					minWidth: '150px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001696'), //토크렌치명
					prop: 'mesEqipNm',
					minWidth: '200px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001319'), //모델명
					prop: 'mdlNm',
					minWidth: '200px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC000019'), //측정치
					minWidth: '500px',
					sortable: false,
					children: [
						{
							label: this.getMessage_('QWCC001697'), // 1회
							prop: 'max2MesNos',
							minWidth: '1px',
							sortable: false
						},
						{
							label: this.getMessage_('QWCC001697'), // 1회
							prop: 'max2MesVal',
							minWidth: '100px',
							sortable: false,
							custom: true
						},
						{
							label: this.getMessage_('QWCC001698'), // 2회
							prop: 'max1MesNos',
							minWidth: '1px',
							sortable: false
						},
						{
							label: this.getMessage_('QWCC001698'), // 2회
							prop: 'max1MesVal',
							minWidth: '100px',
							sortable: false,
							custom: true
						},
						{
							label: this.getMessage_('QWCC001699'), // 3회
							prop: 'maxMesNos',
							minWidth: '1px',
							sortable: false
						},
						{
							label: this.getMessage_('QWCC001699'), // 3회
							prop: 'maxMesVal',
							minWidth: '100px',
							sortable: false,
							custom: true
						}
					]
				},
				{
					label: this.getMessage_('SWCC000491'), // 사양(SPEC)
					prop: 'spcVal',
					minWidth: '100px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC000016'), // 평균
					prop: 'avgVal',
					minWidth: '100px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC000017'), // 표준편차
					prop: 'stdDvatVal',
					minWidth: '100px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001125'), // 결과
					prop: 'rsltCd',
					minWidth: '1px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001125'), // 결과
					prop: 'rsltNm',
					minWidth: '100px',
					sortable: false
				}
			];
		},
		torqRgstExcelCols() {
			//그리드 컬럼
			return [
				{
					label: this.getMessage_('QWCC001692'), // 측정일자
					prop: 'mesDd',
					minWidth: '150px',
					sortable: false,
					form: {
						type: 'date',
						isDisabled: ({ row }) => {
							return row.rowType != 'add' ? true : false;
						}
					}
				},
				{
					label: this.getMessage_('QWCC001588'), // 시간
					prop: 'mesTm',
					minWidth: '150px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001695'), //토크렌치번호
					prop: 'oldMesEqipNo',
					minWidth: '1px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001695'), //토크렌치번호
					prop: 'newMesEqipNo',
					minWidth: '150px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001696'), //토크렌치명
					prop: 'mesEqipNm',
					minWidth: '200px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001319'), //모델명
					prop: 'mdlNm',
					minWidth: '200px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001697'), // 1회
					prop: 'max2MesNos',
					minWidth: '1px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001697'), // 1회
					prop: 'max2MesVal',
					minWidth: '100px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001698'), // 2회
					prop: 'max1MesNos',
					minWidth: '1px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001698'), // 2회
					prop: 'max1MesVal',
					minWidth: '100px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001699'), // 3회
					prop: 'maxMesNos',
					minWidth: '1px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001699'), // 3회
					prop: 'maxMesVal',
					minWidth: '100px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('SWCC000491'), // 사양(SPEC)
					prop: 'spcVal',
					minWidth: '100px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC000016'), // 평균
					prop: 'avgVal',
					minWidth: '100px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC000017'), // 표준편차
					prop: 'stdDvatVal',
					minWidth: '100px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001125'), // 결과
					prop: 'rsltCd',
					minWidth: '1px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001125'), // 결과
					prop: 'rsltNm',
					minWidth: '100px',
					sortable: false
				}
			];
		},
		insVali() {
			return yup.array().of(
				yup.object().shape({
					mesDd: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001692')])),
					mesTm: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001588')])),
					oldMesEqipNo: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001695')])),
					newMesEqipNo: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001695')])),
					// mesEqipNm: yup
					// 	.string()
					// 	.nullable()
					// 	.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001696')])),
					mdlNm: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001319')])),
					max2MesVal: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001697')])),
					max1MesVal: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001698')])),
					spcVal: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('SWCC000491')]))
				})
			);
		}
	}
};
</script>

<style></style>
